import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên khách hàng", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ", -1)
const _hoisted_6 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_8 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Chọn ngày sinh", -1)
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Tên khách hàng", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ", -1)
const _hoisted_21 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_23 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Chọn ngày sinh", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: "Khách hàng",
          style: {"font-weight":"bold"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Thêm khách hàng mới" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_InputText, {
                      id: "tenKhachHang",
                      type: "text",
                      modelValue: $setup.khachHangCreate.tenKhachHang,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.khachHangCreate.tenKhachHang) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_InputText, {
                      id: "diaChi",
                      type: "text",
                      modelValue: $setup.khachHangCreate.diaChi,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.khachHangCreate.diaChi) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_InputText, {
                      id: "soDienThoai",
                      type: "text",
                      modelValue: $setup.khachHangCreate.soDienThoai,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.khachHangCreate.soDienThoai) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.khachHangCreate.ngaySinh,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.khachHangCreate.ngaySinh) = $event)),
                      selectionMode: "single",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "1930:2100"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validKhachHang)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "btn-spa-add",
                      label: "Thêm",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.createKhachHang()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Thêm",
                      class: "btn-spa-add",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "Danh sách khách hàng" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DataTable, {
                    value: $setup.listKhachHang,
                    showGridlines: true,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenKhachHang'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} khách hàng",
                    columnResizeMode: "fit | expand"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"100px","margin-right":"10px"}
                        }),
                        _createElementVNode("span", _hoisted_12, [
                          _hoisted_13,
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên khách hàng"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenKhachHang",
                        header: "Tên khách hàng",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "soDienThoai",
                        header: "Số điện thoại",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "diaChi",
                        header: "Địa chỉ",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "ngaySinh",
                        dataType: "date",
                        header: "Ngày sinh",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaySinh)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngayTao",
                        dataType: "date",
                        header: "Thời gian tạo",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayTao)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        dataType: "date",
                        header: "Tùy chọn",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_Button, {
                            style: {"max-width":"200px"},
                            class: "btn-spa-update",
                            label: "Cập nhật",
                            severity: "warning",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            onClick: ($event: any) => ($setup.selectKhachHang(data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Dialog, {
          visible: $setup.showUpdate,
          "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (($setup.showUpdate) = $event)),
          modal: "",
          blockScroll: "",
          style: { width: '70vw'},
          breakpoints: { '1500px': '50vw', '1150px': '60vw', '800px': '90vw' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Cập nhật khách hàng" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_InputText, {
                      id: "tenKhachHang",
                      type: "text",
                      modelValue: $setup.khachHangUpdate.tenKhachHang,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.khachHangUpdate.tenKhachHang) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_InputText, {
                      id: "diaChi",
                      type: "text",
                      modelValue: $setup.khachHangUpdate.diaChi,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.khachHangUpdate.diaChi) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_InputText, {
                      id: "soDienThoai",
                      type: "text",
                      modelValue: $setup.khachHangUpdate.soDienThoai,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.khachHangUpdate.soDienThoai) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.khachHangUpdate.ngaySinh,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.khachHangUpdate.ngaySinh) = $event)),
                      selectionMode: "single",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "1930:2100"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validKhachHangUpdate)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Cập nhật",
                      class: "btn-spa-update",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      severity: "warning",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.updateKhachHang()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Cập nhật",
                      class: "btn-spa-update",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ], 64))
}